import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { useServices } from '@/hooks/useServices';
import ServiceCard from '@/components/services/ServiceCard';
import SectionHeading from '@/components/common/SectionHeading';

export default function ServicesOverview() {
  const { t } = useTranslation();
  const { popularServices } = useServices();

  return (
    <section className="bg-gray-50 px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          title={t('home.servicesTitle')}
          subtitle={t('home.servicesSubtitle')}
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {popularServices.slice(0, 6).map((service) => (
            <ServiceCard key={service.id} service={service} compact />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 rounded-full border-2 border-primary px-6 py-3 font-semibold text-primary transition-colors hover:bg-primary hover:text-white"
          >
            {t('common.viewAll')}
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
